import { css } from 'linaria';

export const priceContainer = css`
  display: flex;
  align-items: center;
`;

export const verticalContainer = css`
  margin-top: var(--space-100);
  margin-bottom: var(--space-225);
`;

export const linkRow = css`
  position: relative;
  background: var(--brand-primary) !important;
`;

export const buttonText = css`
  color: var(--secondary-red-primary) !important;
`;

export const originalPrice = css`
  flex: 0 0 auto;
  margin-left: var(--space-100);
  margin-right: var(--space-200);
`;

export const flags = css`
  position: absolute;
  right: 0;
  top: 0;
`;

export const container = css`
  @media (--only-desktop) {
    display: flex;
    flex-direction: column;
  }
`;

export const button = css`
  @media (--only-desktop) {
    width: 100%;
  }
`;
